<template>
  <div class="login-forget">

    <div class="logo-text df aic jcsb">
      <img src="../../assets/images/login-logo.png" class="login-logo cup"
        @click="$navigate('/index/index', null, false)" alt="">

      <el-select v-model="langActive" placeholder="请选择" @change="changeLanguage">
        <el-option v-for="item in datalist.lang" :key="item.tws_name" :label="item.tws_name" :value="item.twss_lang">
        </el-option>
      </el-select>
    </div>


    <!-- <img src="../../assets/images/login-logo.png" class="login-logo cup" @click="$navigate('/index/index', null, false)"
      alt="" /> -->

    <template v-if="language == 'zh'">
      <img :src="require('../../assets/images/logintext-zh.png')" class="login-textimg" alt="">
    </template>
    <template v-if="language == 'en'">
      <img :src="require('../../assets/images/logintext-en.png')" class="login-textimg" alt="">
    </template>

    <!-- 账号登录/注册 -->
    <div class="login-content df fdc">
      <div class="over-scoll f1">
        <div class="title df">
          <span class="active">{{ $t("密码找回/创建") }}</span>
        </div>
        <!-- 单选框手机号或者邮箱 -->
        <div class="phone-email mt-40">
          <el-radio-group v-model="propformdata.phoneEmail" @change="handlePhoneEmailChange">
            <el-radio label="phone">{{ $t("手机号") }}</el-radio>
            <el-radio label="email">{{ $t("邮箱") }}</el-radio>
          </el-radio-group>
        </div>

        <el-form ref="form" :model="propformdata" :rules="rules">
          <template v-if="propformdata.phoneEmail == 'phone'">
            <div class="df">
              <el-form-item prop="user_mobile_area_code" class="area-code-item">
                <div class="area-code df aic">
                  <span class="iconfont icon-jia1"></span>
                  <el-input v-model="propformdata.user_mobile_area_code" type="text" @input="validateInput"
                    class="phone-input-item ml-6 mt-0" :placeholder="$t('请输入区号')" />
                </div>
              </el-form-item>
              <el-form-item prop="phone" class="phone-item f1">
                <!-- 手机号输入框 前面加上区号 -->
                <div class="phonecode-input df">
                  <el-input v-model="propformdata.phone" class="phone-input-item ml-8" :placeholder="$t('请输入手机号')"
                    @input="validateInputPhone" />
                </div>
              </el-form-item>
            </div>

            <el-form-item prop="code">
              <!-- 验证码输入框 -->
              <div class="code-input df">
                <el-input v-model="propformdata.code" :placeholder="$t('请输入验证码')" />
                <el-button @click="handleGetCode" :disabled="showCodeTimePhone"
                  :class="{ disabled: showCodeTimePhone }">{{
                    showCodeTimePhone
                      ? $t("重新发送") + " (" + codeTimePhone + ")"
                      : $t("获取验证码")
                  }}</el-button>
              </div>
            </el-form-item>

          </template>

          <!-- 邮箱 -->
          <template v-else>
            <el-form-item prop="email">
              <div class="phone-input">
                <el-input v-model="propformdata.email" class="phone-input-item" :placeholder="$t('请输入邮箱')" />
              </div>
            </el-form-item>

            <el-form-item prop="code">
              <!-- 验证码输入框 -->
              <div class="code-input df">
                <el-input v-model="propformdata.code" :placeholder="$t('请输入验证码')" />
                <el-button @click="handleGetCode" :disabled="showCodeTimeEmail"
                  :class="{ disabled: showCodeTimeEmail }">{{
                    showCodeTimeEmail
                      ? $t("重新发送") + " (" + codeTimeEmail + ")"
                      : $t("获取验证码")
                  }}</el-button>
              </div>
            </el-form-item>
          </template>


          <el-form-item prop="user_pwd_new">
            <div class="phone-input df aic">
              <el-input v-model="propformdata.user_pwd_new" :type="showPwd ? 'text' : 'password'"
                class="phone-input-item" :placeholder="$t('请输入新密码')" />
              <span class="iconfont cup" :class="showPwd ? 'icon-yanjing1' : 'icon-yanjing2'"
                @click="showPwd = !showPwd"></span>
            </div>
          </el-form-item>

          <!-- 请确认新密码 -->
          <el-form-item prop="user_pwd_new_confirm">
            <div class="phone-input df aic">
              <el-input v-model="propformdata.user_pwd_new_confirm" :type="shownewPwd ? 'text' : 'password'"
                class="phone-input-item" :placeholder="$t('请确认新密码')" />

              <span class="iconfont cup" :class="shownewPwd ? 'icon-yanjing1' : 'icon-yanjing2'"
                @click="shownewPwd = !shownewPwd"></span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 登录按钮 -->
      <div class="login-button mt-24">
        <el-button type="primary" @click="handleLogin" :loading="loading">{{
          $t("提交")
        }}</el-button>
        <div class="mt-24 verify-box">
          <!-- 把这个多选变成圆形样式 -->
          <el-checkbox v-model="propformdata.privacy" class="checkbox-circle">{{
            $t("我已阅读并同意")
          }}</el-checkbox><span @click="handleDialogVisible('pri')">
            {{ $t("隐私声明") }}
          </span>
          {{ $t("与") }}
          <span @click="handleDialogVisible('reg')">
            {{ $t("用户注册协议") }}</span>
        </div>
      </div>
    </div>
    <!-- 弹框协议 -->
    <el-dialog :title="dialogTitle" :append-to-body="true" :z-index="2000" :visible.sync="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-content-item" v-html="dialogContent"></div>
      </div>
    </el-dialog>

    <verify ref="verifyModal" @success="verifySuccess" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import verify from "./components/verify.vue";
import Cookies from 'js-cookie';
import {

  getSmsCaptchaNew,
  getEmailCodeNew,
  userFirstEditView,
  user_first_edit,
  getDistrict,
  userPriRegInfo,
  forgot,
} from "@api/user";
export default {
  components: {
    verify
  },
  data() {
    return {

      langActive: 'zh',


      // 图形验证
      isNew: true,

      aes_key: 'ed8222',
      aes_script: '8NONwyJt',



      showPwd: false,
      shownewPwd: false,
      loading: false,
      propformdata: {
        phoneEmail: "phone",
        phoneCode: "86",
        user_mobile_area_code: "86",
        phone: "",
        email: "",
        code: "",
        user_pwd_new: "",
        user_pwd_new_confirm: "",
        privacy: true,
      },
      rules: {
        user_mobile_area_code: [{ required: true, message: this.$t("请输入区号"), trigger: "blur" }],
        phone: [{ required: true, message: this.$t("请输入手机号"), trigger: "blur" }],
        email: [{ required: true, message: this.$t("请输入邮箱"), trigger: "blur" }],
        code: [{ required: true, message: this.$t("请输入验证码"), trigger: "blur" }],
        user_pwd_new: [{ required: true, message: this.$t("请输入密码"), trigger: "blur" }],
        user_pwd_new_confirm: [
          { required: true, message: this.$t("请确认新密码"), trigger: "blur" },
        ],
      },

      // 验证码倒计时
      codeTimePhone: 60,
      showCodeTimePhone: false,
      timerPhone: null,

      codeTimeEmail: 60,
      showCodeTimeEmail: false,
      timerEmail: null,

      // 弹框协议
      dialogVisible: false,
      dialogTitle: "",
      dialogContent: "",

      // 获取当前语言
      language: this.$i18n.locale,
    };
  },
  computed: {
    // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter
    ...mapGetters('home', ['datalist'])

  },


  mounted() {

    this.langActive = localStorage.getItem('currentLanguage');

    if (this.language == 'en') {
      this.propformdata.phoneEmail = 'email';
      this.propformdata.privacy=false;
    }
    this.getUserPriReg();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.callback = urlParams.get("callback");
    console.log(this.callback);

    this.fetchDatalist(); // 调用 action 加载数据列表

  },
  methods: {

    ...mapActions('home', ['fetchDatalist']), // 使用命名空间访问 home 模块的 actions

    getCallbackFromUrl(url) {
    const urlObj = new URL(url);
    const callback = urlObj.searchParams.get('callback');
    return callback;
},

    // 切换语言
    changeLanguage(data) {
      // window.location.pathname;
      // window.location.href.replace(window.location.origin, '')

      let callback=this.getCallbackFromUrl(window.location.href);

      const currentUrl = window.location.pathname;
      let newUrl="";
      if (data == 'en') {
        let pattern = /\/cn\//;
        let replacement = "/en/";
        newUrl = currentUrl.replace(pattern, replacement);

        // callback=callback.replace('/cn/','/en/');
        callback='/en/index/index';
        Cookies.set('siteData', '{"tws_id":2,"apply_site":"protal_en"}');
      } else {
        let pattern = /\/en\//;
        let replacement = "/cn/";
        newUrl = currentUrl.replace(pattern, replacement);
        // callback=callback.replace('/en/','/cn/');
        callback='/cn/index/index';
        Cookies.set('siteData', '{"tws_id":1,"apply_site":"protal"}');
      }
      localStorage.setItem('currentLanguage', data);
      this.$i18n.locale = data;
      setTimeout(() => {
        this.$forceUpdate();
        // 设置 url 参数 callback
        if (callback) {
          newUrl = newUrl + '?callback=' + callback;
        }
        // window.location.href = newUrl;

        if (callback) {
          newUrl = newUrl + '?callback=' + callback;
        }
        // window.location.href = newUrl;
        try {
          window.close();
          console.log("Closing the window is not allowed in some browsers.")
        } catch (e) {
          // console.warn('Closing the window is not allowed in some browsers.');
        }
        // 打开新窗口
        window.open(newUrl, '_blank');
        // 关闭当前窗口


      }, 20);

    },


    // 图形验证成功 !
    verifySuccess() {
      this.handleGetCode();
    },

    validateInput(value) {
      // 使用正则表达式验证输入内容
      const regex = /^[0-9]*$/; // 只允许输入数字
      if (!regex.test(value)) {
        // 如果输入的不是数字，去掉最后一个字符
        this.propformdata.user_mobile_area_code = value.replace(/[^0-9]/g, ""); // 替换非数字字符
      }
    },
    validateInputPhone(value) {
      // 使用正则表达式验证输入内容
      const regex = /^[0-9]*$/; // 只允许输入数字
      if (!regex.test(value)) {
        // 如果输入的不是数字，去掉最后一个字符
        this.propformdata.phone = value.replace(/[^0-9]/g, ""); // 替换非数字字符
      }
    },

    async getUserPriReg() {
      let res = await userPriRegInfo();
      this.priReg = res.data;

    },
    // 弹框协议
    handleDialogVisible(type) {
      this.dialogVisible = true;
      if (type == "pri") {
        this.dialogTitle = this.priReg.privacyPro.tsap_title;
        this.dialogContent = this.priReg.privacyPro.tsap_content;
      } else {
        this.dialogTitle = this.priReg.registerPro.tsap_title;
        this.dialogContent = this.priReg.registerPro.tsap_content;
      }
    },
    // 提交
    handleLogin() {
      this.loading = true;
      this.propformdata.user_pwd_new_confirm = this.propformdata.user_pwd_new_confirm ? this.propformdata.user_pwd_new_confirm.trim() : '';
      this.propformdata.user_pwd_new = this.propformdata.user_pwd_new ? this.propformdata.user_pwd_new.trim() : '';
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.propformdata.privacy) {
            // 使用正则表达式匹配表情符号
            const emojiRegex =
              /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FB00}-\u{1FBFF}]/gu;
            // 检查是否包含表情符号
            if (emojiRegex.test(this.propformdata.user_pwd_new_confirm.trim())) {
              this.loading = false;
              return this.$message.error(this.$t("密码请不要输入表情符号"));
            }

            if (emojiRegex.test(this.propformdata.user_pwd_new.trim())) {
              this.loading = false;
              return this.$message.error(this.$t("密码请不要输入表情符号"));
            }

            if (this.propformdata.user_pwd_new != this.propformdata.user_pwd_new_confirm) {
              this.loading = false;
              return this.$message.error(this.$t("两次密码输入不一致"));
            }


            if (this.propformdata.phoneEmail == "phone") {
              this.propformdata.register_type = 1;
              this.propformdata.user_account = this.propformdata.phone;
            } else {
              this.propformdata.register_type = 2;
              this.propformdata.user_account = this.propformdata.email;
            }
            let res = await forgot(this.propformdata);
            this.loading = false;
            if (res.status == 200) {
              this.$message.success(res.msg);
              // 清理 localStorage
              localStorage.removeItem('userinfo');
              Cookies.remove('accessToken');
              // 跳转页面
              this.$navigate('/login/2?callback=' + this.callback, null, false);

              return false;
            }
          } else {
            this.loading = false;
            return this.$message.error(
              this.$t("请勾选隐私声明")
            );
          }
        } else {

          this.loading = false;
        }
      });
    },
    async handleGetCode() {

      var this_ = this;

      // 验证手机号
      if (this.propformdata.phoneEmail == "phone") {
        // 验证手机号是否为空
        if (!this.propformdata.phone) {
          this.$message.error(this.$t("请输入手机号"));
          return;
        }

        let phone = this.isNew ? this.$encryptByAES(this.propformdata.phone, this.aes_key, this.aes_script) : this.propformdata.phone;


        let codeRes = await getSmsCaptchaNew({
          phone: phone,
          px: "backpwd_",
          areacode: this.propformdata.user_mobile_area_code,
        }); 


        if (codeRes.status == '400C1' && this.isNew) {
          this.$refs.verifyModal.openModal(phone);
          return false;
        }



        if (codeRes.status == 200) {

          let time = 60;
          this.showCodeTimePhone = true;
          this.timerPhone = setInterval(() => {
            time--;
            this.codeTimePhone = time;
            if (time <= 0) {
              clearInterval(this_.timerPhone);
              this_.showCodeTimePhone = false;

              this.codeTimePhone = 60;
            }
          }, 1000);

        }

        /**
         * 2025-4-10生成任意的验证到输入框
         * start
         */
        // setTimeout(() => {
        //   this.propformdata.code = Math.floor(Math.random() * 900000) + 100000;
        // }, 2000);
        /**
        * 2025-4-10生成任意的验证到输入框
        * end
        */


        // 验证手机号格式
        // const phoneRegex = /^1[3-9]\d{9}$/;
        // if (!phoneRegex.test(this.propformdata.phone)) {
        //   this.$message.error("请输入正确的手机号");
        //   return;
        // }
      }
      // 验证邮箱
      if (this.propformdata.phoneEmail == "email") {
        // 验证邮箱是否为空
        if (!this.propformdata.email) {
          this.$message.error(this.$t("请输入邮箱"));
          return;
        }
        // 验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.propformdata.email)) {
          this.$message.error(this.$t("请输入正确的邮箱"));
          return;
        }

        let codeRes = await getEmailCodeNew({
          email: this.propformdata.email,
          px: "backpwd_",
        });

        if (codeRes.status == 200) {

          // 验证码倒计时
          // codeTimePhone: 60,
          // showCodeTimePhone: false,
          // timerPhone: null,

          // codeTimeEmail: 60,
          // showCodeTimeEmail: false,
          // timerEmail: null,
          // 倒计时
          let time = 60;
          this.showCodeTimeEmail = true;
          this.timerEmail = setInterval(() => {
            time--;
            this.codeTimeEmail = time;
            if (time <= 0) {
              clearInterval(this_.timerEmail);
              this_.showCodeTimeEmail = false;

              this.codeTimeEmail = 60;
            }
          }, 1000);
        }

      }

      if (this.propformdata.phoneEmail == "phone") {

      } else {

      }

      // 倒计时
      // let time = 60;
      // this.showCodeTime = true;
      // this.timer = setInterval(() => {
      //   time--;
      //   this.codeTime = time;
      //   if (time <= 0) {
      //     clearInterval(this_.timer);
      //     this_.showCodeTime = false;
      //   }
      // }, 1000);
    },
    // 手机号或者邮箱切换
    handlePhoneEmailChange(val) {

      if(val=='email'){
        this.propformdata.privacy=false;
      }else{
        this.propformdata.privacy=true;
      }

      this.$refs.form.resetFields(); // 重置表单字段

      this.propformdata.phone = "";
      this.propformdata.email = "";
      this.propformdata.user_mobile_area_code = "86";

      // this.codeTime = 60;
      // this.showCodeTime = false;
      // clearInterval(this.timer);
    },
  },
};
</script>

<style lang="scss" scoped>

.logo-text {
  padding: 40px;
}



.area-code-item {
  width: 152px;
}

::v-deep() {
  .el-dialog__body {
    max-height: calc(70vh - 54px);
    margin-bottom: 24px;
    padding: 24px 0;

    // overflow-y: scroll;
    .dialog-content {
      width: 100%;
      max-height: calc(70vh - 102px);
      padding: 0 24px;
      overflow: hidden;
      overflow-y: scroll;

      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #B7251E;
      }
    }
  }

  .el-input__inner {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.login-forget {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login-bg.png") no-repeat left bottom;
  background-size: cover;
  background-color: #fff;
  position: relative;

  .login-textimg {
    width: 44.43%;
    position: absolute;
    left: 120px;
    top: 30%;
  }

  .login-forget-box {
    width: 520px;
    height: 678px;
    max-height: 92vh;
    background: #fff;
    border-radius: 16px;
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
    padding: 60px;

    .title {
      font-size: 20px;
      line-height: 30px;
      color: rgb(25, 25, 25);

      span {
        font-size: 20px;
        line-height: 30px;


        position: relative;
      }

      span.active::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 2px;
        background: #b7251e;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}

::v-deep() {
  .phone-item .el-form-item__error {
    left: 6px;
  }

  .el-form-item {
    margin-bottom: 0;
  }
}

.verify-box {
  font-size: 12px;
  line-height: 22px;
  color: #aeaeae;

  span {
    color: #b7251e;
    cursor: pointer;
  }
}

.checkbox-circle {
  ::v-deep() {
    .el-checkbox__inner {
      width: 19px;
      height: 19px;
      border-radius: 50%;
    }

    .el-checkbox__inner::after {
      width: 4px;
      left: 6px;
      top: 3px;
    }

    .el-checkbox__label {
      font-size: 12px;
      line-height: 22px;
      color: #aeaeae;
      padding-left: 6px;
    }
  }
}

* {
  font-family: "harmonyos";
  font-weight: 400;
}

::v-deep() {
  .el-radio__inner {
    width: 20px;
    height: 20px;
    border: 2px solid rgb(183, 37, 30) !important;
  }
}

.login-button {
  .el-button--primary {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    padding: 0;
    background: rgb(183, 37, 30);
    color: rgb(255, 255, 255);
    font-size: 16px;
  }
}

.phonecode-input {

  // height: 60px;
  // border-radius: 8px;
  // background: rgb(245, 248, 255);
  // padding: 10px 16px;
  // margin-top: 24px;
  .phone-input-item {
    height: 60px;
    border-radius: 8px;
    background: rgb(245, 248, 255);
    padding: 10px 16px;
    margin-top: 24px;
  }

  ::v-deep() {
    .el-input--suffix .el-input__inner {
      border: none;
      background: transparent;
      padding-right: 0;

      color: rgb(179, 179, 179);

      font-size: 14px;
    }

    .el-input__inner {
      padding: 0;
      border: none;
      background: transparent;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-select .el-input__suffix {
      display: none;
    }
  }
}

.phone-input {

  height: 60px;
  border-radius: 8px;
  background: rgb(245, 248, 255);
  padding: 10px 16px;
  margin-top: 24px;

  ::v-deep() {
    .el-input--suffix .el-input__inner {
      border: none;
      background: transparent;
      padding-right: 0;

      color: rgb(179, 179, 179);

      font-size: 14px;
    }

    .el-input__inner {
      padding: 0;
      border: none;
      background: transparent;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-select .el-input__suffix {
      display: none;
    }
  }

}

.code-input,
.area-code {
  width: 400px;
  height: 60px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: rgb(245, 248, 255);
  margin-top: 24px;

  ::v-deep() {
    .el-button.disabled {
      color: #b3b3b3;
    }

    .el-input__inner {
      border: none;
      background: transparent;
      padding: 0;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
      color: rgb(183, 37, 30);
      font-size: 14px;
    }
  }
}

.area-code {
  width: auto;

  // padding: 0 16px;
  span.iconfont {
    font-size: 14px;
    color: #000000;
  }

  ::v-deep(.phone-input-item) {
    padding: 10px 0;
  }
}


.login-content {
  width: 520px;
  height: 678px;
  max-height: 96vh;
  border-radius: 16px;
  box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
  background: rgb(255, 255, 255);
  padding: 60px;
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  .over-scoll{
    overflow: hidden;
    overflow-y: scroll;
    width: calc(100% + 60px);
    padding-right: 60px;
   
  &::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #B7251E; 
  }
    // max-height: calc(70vh - 102px);
    // padding: 0 24px;
  }
}

.title {
  font-size: 20px;
  line-height: 30px;
  color: rgb(25, 25, 25);

  span {
    font-size: 20px;
    line-height: 30px;

    position: relative;
  }

  span.active::after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 2px;
    background: #b7251e;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>